/**
 * Extract a `matchId` from user input on the Home screen. Accepts:
 *   • Bare id: `abc123`
 *   • Path hash: `#/join/abc123`
 *   • Full URL: `https://pit.example.com/#/join/abc123`
 *
 * Returns `null` if nothing recognizable is present. Non-throwing.
 *
 * Kept pure so the input field can validate/enable the Join button
 * without a mount + testing-library round-trip.
 */

export function extractMatchId(raw: string): string | null {
  const trimmed = raw.trim();
  if (trimmed.length === 0) return null;
  // Full URL with hash.
  const hashIdx = trimmed.indexOf("#/join/");
  if (hashIdx >= 0) {
    const tail = trimmed.slice(hashIdx + "#/join/".length);
    const cut = tail.split(/[/?&#]/)[0];
    if (cut !== undefined && cut.length > 0 && cut.length <= 64) return cut;
    return null;
  }
  // Bare id: alphanumeric + dashes + underscores. Reject URLs without
  // the join fragment.
  if (/^[A-Za-z0-9._-]{1,64}$/.test(trimmed)) return trimmed;
  return null;
}
